import { render, staticRenderFns } from "./GridTable.vue?vue&type=template&id=a572c508&scoped=true&"
import script from "./GridTable.vue?vue&type=script&lang=js&"
export * from "./GridTable.vue?vue&type=script&lang=js&"
import style0 from "./GridTable.vue?vue&type=style&index=0&id=a572c508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a572c508",
  null
  
)

export default component.exports